module.exports = __webpack_public_path__ + "static/media/dialog-image-1.e869f961.png";